<loren-trace-dialog
  title="operations.color_select"
  subtitle="operations.choose_colors_for_selected_asset"
  (continue)="continue()"
  >@if (formModel) {
  <loren-entity-form
    class="loren-trace-color-selector-dialog"
    [formModel]="formModel"
    >
    </loren-entity-form
    >
  }</loren-trace-dialog>
